
// // new with working checkboxes
// import React from "react";

// const ReadOnlyRow = ({
//   contact,
//   handleEditClick,
//   handleDeleteClick,
//   handleDownloadRow,
//   selectedRecords = [],
//   handleSelectRecord = () => {},
// }) => {
//   const isApproved =
//     String(contact?.approved_status || "").toLowerCase() === "approved";

//   return (
//     <tr
//       className="
//         striped--light-gray
//         hover-bg-near-white
//         bb
//         b--black-10 fw4
//       "
//     >
//       {/* Select */}
//       <td className="pa2 tc nowrap">
//         <input
//           type="checkbox"
//           checked={selectedRecords.includes(contact.id)}
//           onChange={() => handleSelectRecord(contact.id)}
//         />
//       </td>

//       {/* ID */}
//       <td className="pa2 nowrap ">
//         {contact.id}
//       </td>

//       {/* Farmer ID */}
//       <td className="pa2 nowrap">
//         {contact.farmerid}
//       </td>

//       {/* Product */}
//       <td className="pa2 nowrap">
//         {contact.producttype}
//       </td>

//       {/* Weight */}
//       <td className="pa2 tr nowrap">
//         {contact.weight}
//       </td>

//       {/* Company */}
//       <td className="pa2 nowrap">
//         {contact.companyname}
//       </td>

//       {/* Full Name */}
//       <td className="pa2 nowrap">
//         {contact.fullname}
//       </td>

//       {/* Approval */}
//       <td className="pa2 tc nowrap">
//         {isApproved ? (
//           <span
//             className="
//               dib
//               br-pill
//               ph3
//               pv2
//               bg-light-green
//               dark-green
//               fw6
//               f7
//               ba
//               b--green
//             "
//           >
//             ✓ Approved
//           </span>
//         ) : (
//           <span
//             className="
//               dib
//               br-pill
//               ph3
//               pv2
//               bg-washed-red
//               dark-red
//               fw6
//               f7
//               ba
//               b--light-red
//             "
//           >
//             ✕ Not Approved
//           </span>
//         )}
//       </td>

//       {/* Date Approved */}
//       <td className="pa2 tc nowrap">
//         {contact.date_approved || "-"}
//       </td>

//       {/* Date Recorded */}
//       <td className="pa2 tc nowrap">
//         {contact.daterecorded}
//       </td>

//       {/* Actions */}
//       <td className="pa2 tc nowrap">

//         <button
//           type="button"
//           className="
//             bn
//             bg-transparent
//             pointer
//             mh1
//           "
//           onClick={(event) =>
//             handleEditClick(event, contact)
//           }
//           title="Edit"
//         >
//           <i className="fas fa-edit f4 gold hover-orange"></i>
//         </button>

//         <button
//           type="button"
//           className="
//             bn
//             bg-transparent
//             pointer
//             mh1
//           "
//           onClick={() => handleDownloadRow(contact)}
//           title="Download"
//         >
//           <i className="fas fa-download f4 green hover-dark-green"></i>
//         </button>

//         <button
//           type="button"
//           className="
//             bn
//             bg-transparent
//             pointer
//             mh1
//           "
//           onClick={() => handleDeleteClick(contact.id)}
//           title="Delete"
//         >
//           <i className="fas fa-trash f4 red hover-dark-red"></i>
//         </button>

//       </td>
//     </tr>
//   );
// };

// export default ReadOnlyRow;

// new a little improved
import React from "react";
const ReadOnlyRow = ({
  contact,
  handleEditClick,
  handleDeleteClick,
  handleDownloadRow,
  selectedRecords = [],
  handleSelectRecord = () => {},
  deletingId, // FIX (#3): id of the row currently being deleted, or null
}) => {
  const isApproved =
    String(contact?.approved_status || "").toLowerCase() === "approved";

  const isDeleting = deletingId === contact.id;

  return (
    <tr
      className={`
        striped--light-gray
        hover-bg-near-white
        bb
        b--black-10 fw4
        ${isDeleting ? "o-50" : ""}
      `}
    >
      {/* Select */}
      <td className="pa2 tc nowrap">
        <input
          type="checkbox"
          checked={selectedRecords.includes(contact.id)}
          onChange={() => handleSelectRecord(contact.id)}
        />
      </td>
      {/* ID */}
      <td className="pa2 nowrap ">
        {contact.id}
      </td>
      {/* Farmer ID */}
      <td className="pa2 nowrap">
        {contact.farmerid}
      </td>
      {/* Product */}
      <td className="pa2 nowrap">
        {contact.producttype}
      </td>
      {/* Weight */}
      <td className="pa2 tr nowrap">
        {contact.weight}
      </td>
      {/* Company */}
      <td className="pa2 nowrap">
        {contact.companyname}
      </td>
      {/* Full Name */}
      <td className="pa2 nowrap">
        {contact.fullname}
      </td>
      {/* Approval */}
      <td className="pa2 tc nowrap">
        {isApproved ? (
          <span
            className="
              dib
              br-pill
              ph3
              pv2
              bg-light-green
              dark-green
              fw6
              f7
              ba
              b--green
            "
          >
            ✓ Approved
          </span>
        ) : (
          <span
            className="
              dib
              br-pill
              ph3
              pv2
              bg-washed-red
              dark-red
              fw6
              f7
              ba
              b--light-red
            "
          >
            ✕ Not Approved
          </span>
        )}
      </td>
      {/* Date Approved */}
      <td className="pa2 tc nowrap">
        {contact.date_approved || "-"}
      </td>
      {/* Date Recorded */}
      <td className="pa2 tc nowrap">
        {contact.daterecorded}
      </td>
      {/* Actions */}
      <td className="pa2 tc nowrap">
        <button
          type="button"
          className="
            bn
            bg-transparent
            pointer
            mh1
          "
          onClick={(event) =>
            handleEditClick(event, contact)
          }
          title="Edit"
        >
          <i className="fas fa-edit f4 gold hover-orange"></i>
        </button>
        <button
          type="button"
          className="
            bn
            bg-transparent
            pointer
            mh1
          "
          onClick={() => handleDownloadRow(contact)}
          title="Download"
        >
          <i className="fas fa-download f4 green hover-dark-green"></i>
        </button>
        <button
          type="button"
          className="
            bn
            bg-transparent
            pointer
            mh1
          "
          onClick={() => handleDeleteClick(contact.id)}
          disabled={isDeleting}
          title={isDeleting ? "Deleting..." : "Delete"}
        >
          {isDeleting ? (
            <i className="fas fa-spinner fa-spin f4 red"></i>
          ) : (
            <i className="fas fa-trash f4 red hover-dark-red"></i>
          )}
        </button>
      </td>
    </tr>
  );
};
export default ReadOnlyRow;